// extracted by mini-css-extract-plugin
export default {"wrapper":"OtpInput_wrapper__w4Y+B","otp__wrapper":"OtpInput_otp__wrapper__VQQKw","otp__wrapper_invalid":"OtpInput_otp__wrapper_invalid__sXaIL","input":"OtpInput_input__ADMkC"};